<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="tit"><b><i>Memphis</i></b></p>
<p class="tit1"><b><i>B<span class="small">LUES</span></i></b></p>
<p class="tit2">B<span class="small">IRTHPLACE OF A</span><br/>M<span class="small">USIC</span> T<span class="small">RADITION</span></p>
<p class="tit3">William Bearden</p>
<p class="tit3">Foreword by Knox Phillips</p>
<p class="tit4"><img alt="Images" class="c1" src="Images/logo.gif"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3595efda